import React from 'react';
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';
import DragHandle from '@sg/assests/svg/draghandle-icon.svg';
import type { IGggFinanceProjectRow } from '../../../types';
import FinanceMetricBoard from './FinanceMetricBoard';
import RevenueAfterRefundCell from './RevenueAfterRefundCell';
import {
  buildTrendData,
  formatMoM,
  formatPayerRatio,
  getFinanceMetricTip,
} from './utils';
import './index.scss';
import './FinanceMetricBoard/index.scss';
import './RevenueAfterRefundCell/index.scss';
import '@sg/pages/StudioManagement/LiveTitles/utils/liveMetricTrendChart/index.scss';

interface IFinanceProjectRowProps {
  project: IGggFinanceProjectRow;
  isEditing?: boolean;
  dragHandleProps?: Record<string, unknown>;
}

const FinanceProjectRow: React.FC<IFinanceProjectRowProps> = ({
  project,
  isEditing = false,
  dragHandleProps,
}) => {
  return (
    <div className="dbs-ltf-project-row-drag-handle-wrapper">
      {isEditing && (
        <div className="dbs-ltf-project-row-drag-handle" {...dragHandleProps}>
          <img
            className="dbs-ltf-project-row-drag-handle__icon"
            src={DragHandle}
            alt="Drag handle"
          />
        </div>
      )}
      <div className="dbs-ltf-project-card">
        <div className="dbs-ltf-project-card__header">
          <img
            className="dbs-ltf-project-card__icon"
            src={project?.cover || GameDefault}
            alt={project?.game_title}
          />
          <div className="dbs-ltf-project-card__name">
            {project?.game_title || '-'}
          </div>
        </div>

        <div className="dbs-ltf-project-card__metrics">
          <div className="dbs-ltf-project-card__metric dbs-ltf-project-card__metric--revenue">
            <RevenueAfterRefundCell
              title="Revenue After Refund ($)"
              tipString={getFinanceMetricTip(
                project?.game_title,
                'revenue_after_refund',
              )}
              gameTitle={project?.game_title}
              metric={project?.revenue_after_refund}
              baseGameUnits={project?.base_game_units_after_refund}
            />
          </div>

          <div className="dbs-ltf-project-card__metric">
            <FinanceMetricBoard
              title="MAU"
              tipString={getFinanceMetricTip(project?.game_title, 'mau')}
              num={project?.mau?.value}
              formatter="db_bmk0"
              momText={formatMoM(project?.mau?.mom)}
              trendData={buildTrendData(project?.mau?.timeline, 'mau')}
            />
          </div>

          <div className="dbs-ltf-project-card__metric">
            <FinanceMetricBoard
              title="ARPU ($)"
              tipString={getFinanceMetricTip(project?.game_title, 'arpu')}
              num={project?.arpu?.value}
              formatter="db_bm00"
              unit="USD"
              momText={formatMoM(project?.arpu?.mom)}
              trendData={buildTrendData(project?.arpu?.timeline, 'arpu')}
            />
          </div>

          {/* <div className="dbs-ltf-project-card__metric">
            <FinanceMetricBoard
              title="Payer Ratio"
              displayValue={formatPayerRatio(project?.payer_ratio?.value)}
              momText={formatMoM(project?.payer_ratio?.mom)}
              trendData={buildTrendData(project?.payer_ratio?.timeline, 'payer_ratio')}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default FinanceProjectRow;
